module.exports = "/legacy/348d250d0eb76db86543e35edc8ab8f6.svg";